import { isAffiliateLinkModalOpenAtom } from '@/components/modal/affiliate-link-modal.atoms';
import { useIsEvidenceOnlyUser } from '@/hooks/useIsEvidenceOnlyUser';
import { trackGettingStartedPanelOpenReferralModal } from '@/lib/analytics/scribe/getting-started';
import { isOnPrem } from '@/utils/buildProfile';
import { isReferralProgramAvailableForLocale } from '@/utils/i18n/referralProgramLocale';
import { Button } from '@heidi/design-system/button';
import { TypographyCaption, TypographyP2Bold } from '@heidi/design-system/typography';
import { useSetAtom } from 'jotai';
import { FormattedMessage, useIntl } from 'react-intl';

/**
 * Refer-and-earn CTA shown at the bottom of the completed onboarding tutorial.
 *
 * The affiliate/referral program is a cloud offering, so this renders nothing on
 * on-prem builds.
 */
export const ReferralSection = () => {
  const setIsAffiliateLinkModalOpen = useSetAtom(isAffiliateLinkModalOpenAtom);
  const intl = useIntl();
  const { isEvidenceOnlyUser } = useIsEvidenceOnlyUser();

  // The refer-and-earn affiliate program is a cloud offering — hide it on-prem.
  if (isOnPrem || !isReferralProgramAvailableForLocale(intl.locale)) return null;

  const referAndEarnText = isEvidenceOnlyUser
    ? intl.formatMessage({ defaultMessage: 'Refer & earn $25', id: 'fs9UsvaA/m' })
    : intl.formatMessage({ defaultMessage: 'Refer & earn $50', id: 'dOnpnODamB' });

  return (
    <div className="mt-2 flex items-center justify-between gap-2 border-t border-border pt-4">
      <TypographyCaption className="text-text-secondary">
        <FormattedMessage
          defaultMessage="Know someone who could use some hours back?"
          id="8oMW1VeTe2"
        />
      </TypographyCaption>
      <Button
        disableAutomaticSvgSizing
        variant="secondary"
        size="sm"
        className="w-full"
        onClick={() => {
          trackGettingStartedPanelOpenReferralModal();
          setIsAffiliateLinkModalOpen(true);
        }}
      >
        <TypographyP2Bold>{referAndEarnText}</TypographyP2Bold>
      </Button>
    </div>
  );
};
